import { useDispatch, useSelector } from "react-redux";

import { Button } from "@mui/material";

import { i18n } from "services/i18nService";
import { importViaEdi } from "services/sosInventoryService/sosApi";

import { usePrivileges } from "hooks/usePrivileges";

import { openAlert } from "globalState/alertSlice";
import {
  loadingIndicatorOn,
  loadingIndicatorOff,
} from "globalState/loadingSlice";

import { USER_PRIVILEGE } from "appConstants";

export function EdiImport() {
  const dispatch = useDispatch();

  const { hasPrivilegesOrIsAdmin } = usePrivileges();

  const ediEnabled = useSelector(
    (state) => state.userCompanySettings.settings.ediEnabled
  );

  const editSalesOrders = hasPrivilegesOrIsAdmin(
    USER_PRIVILEGE.editSalesOrders
  );

  async function ediImport() {
    dispatch(loadingIndicatorOn());
    const { success, message } = await importViaEdi();
    if (success) {
      dispatch(
        openAlert({ type: "success", message: i18n(`alert.SuccesUpdate`) })
      );
    } else {
      const errorMessage = message || i18n("alert.UnableToUpdate");
      openAlert({ type: "error", message: errorMessage });
    }
    dispatch(loadingIndicatorOff());
  }

  if (!ediEnabled || !editSalesOrders) {
    return null;
  }

  return (
    <Button sx={{ lineHeight: "normal" }} onClick={ediImport}>
      {i18n("entityActions.EdiImport")}
    </Button>
  );
}
